import { createSlice } from "@reduxjs/toolkit";
import { getManagerAccessLogsAction } from "../actions/managerAccessLogActions";

export interface IManagerAccessLogEntry {
  id: number;
  requestedById: number;
  requestedByName: string;
  grantedById: number | null;
  grantedByName: string | null;
  actionType: string;
  cashierPointId: number | null;
  cashierPointName: string | null;
  storeId: number | null;
  status: string;
  createdAt: string;
}

export interface IManagerAccessLogState {
  logs: IManagerAccessLogEntry[];
  logsLoading: boolean;
  logsError: string | null;
}

const initialState: IManagerAccessLogState = {
  logs: [],
  logsLoading: false,
  logsError: null,
};

const managerAccessLogSlice = createSlice({
  name: "managerAccessLog",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getManagerAccessLogsAction.pending, (state) => {
        state.logsLoading = true;
        state.logsError = null;
      })
      .addCase(getManagerAccessLogsAction.fulfilled, (state, action) => {
        state.logsLoading = false;
        state.logs = action.payload || [];
      })
      .addCase(getManagerAccessLogsAction.rejected, (state, action) => {
        state.logsLoading = false;
        state.logsError = action.payload as string;
      });
  },
});

export default managerAccessLogSlice.reducer;
